import zegel from "../../assets/img/zegel.png";
import logoIntercorp from "../../assets/img/logo_intercorp.png";

const FooterInterno = () => {
  return (
    <div className="dashboard-footer">
      <div className="footer-content">
        <div style={{ height: 16 }}>
          <p style={{ color: "#fff", fontSize: 12 }}>Con resplado de: </p>
        </div>
        <div className="flex align-items-center gap-4 mt-2">
          <img
            src={zegel}
            height={40} style={{ height: 40 }}
          ></img> 
          <img
            src={logoIntercorp}
            height={20} style={{ height: 20 }}
          ></img>
        </div>
      </div>
    </div>
  );
};

export default FooterInterno;
